import { inject } from '@angular/core';
import { Router } from '@angular/router';

export abstract class ListComponent {
  router = inject(Router);

  onAuxClick(event: MouseEvent, urlTree: string[]) {
    if (event.button === 0 || event.button === 1) {
      event.preventDefault();
      const url = this.router.serializeUrl(this.router.createUrlTree(urlTree));
      window.open(url, '_blank');
      return false;
    }
    return true;
  }
}
